import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  showMinorMenu: Subject<boolean> = new Subject();
  showTutorMenu: Subject<boolean> = new Subject();
  constructor() { }

  setMenu(isMinorMenu:boolean,isTutorMenu:boolean){
    this.showMinorMenu.next(isMinorMenu);
    this.showTutorMenu.next(isTutorMenu);
  }
}
